import { QuickLinkTrayState } from 'src/AppState/CmsState/QuickLinkTrayState/QuickLinkTrayState';
import { QuickLinkTrayPropsType } from './QuickLinkTrayListItem';

export class QuickLinkTrayListItemState {
    public constructor(
        private readonly quickLinkTrayState: QuickLinkTrayState,
        private readonly props: QuickLinkTrayPropsType
    ) {}

    public onChangePageToEdit = async (): Promise<void> => {
        this.quickLinkTrayState.setEditMode(true);
        await this.quickLinkTrayState.setEditQuickLinkTray(this.props.quickLinkTrayItem);
    };

    public onRemove = async (): Promise<void> => {
        await this.quickLinkTrayState.handleRemoveApiCall(this.props.quickLinkTrayItem.id);
    };

    public changeActiveFlag = (): void => {
        this.quickLinkTrayState.setActiveFlag(this.props.quickLinkTrayItem);
    };

    public moveItemUp = async (): Promise<void> => {
        await this.quickLinkTrayState.moveItemUp(this.props.quickLinkTrayItem.id);
    };

    public moveItemDown = async (): Promise<void> => {
        await this.quickLinkTrayState.moveItemDown(this.props.quickLinkTrayItem.id);
    };
}
